import { YStack, XStack, Text, styled } from 'tamagui'
import { Accordion } from '../ui'
import { copy } from '../../content/copy'

const Section = styled(YStack, {
  name: 'FAQSection',
  paddingHorizontal: '$6',
  paddingVertical: '$16',
  backgroundColor: '$background',

  '$md': {
    paddingHorizontal: '$4',
    paddingVertical: '$10',
  },
})

const Container = styled(YStack, {
  name: 'Container',
  maxWidth: 800,
  marginHorizontal: 'auto',
  width: '100%',
  gap: '$8',
})

const Header = styled(YStack, {
  name: 'Header',
  gap: '$3',
  marginBottom: '$4',
})

const HeaderRow = styled(XStack, {
  name: 'HeaderRow',
  alignItems: 'flex-start',
  gap: '$4',
})

const SectionNumber = styled(Text, {
  name: 'SectionNumber',
  fontFamily: '$accent',
  fontSize: '$2',
  color: '$textMuted',
  letterSpacing: 2,
})

const SectionTitle = styled(Text, {
  name: 'SectionTitle',
  // @ts-ignore - Tamagui's `render` controls the underlying HTML element on web
  render: 'h2',
  fontFamily: '$accent',
  fontSize: '$3',
  color: '$orangePrimary',
  letterSpacing: 2,
  textTransform: 'uppercase',
})

export function FAQSection() {
  const { sectionNumber, sectionTitle, questions } = copy.faq

  return (
    <Section id="faq">
      <Container>
        <Header>
          <HeaderRow>
            <SectionNumber>{sectionNumber}</SectionNumber>
            <SectionTitle>{sectionTitle}</SectionTitle>
          </HeaderRow>
        </Header>

        <Accordion items={questions} />
      </Container>
    </Section>
  )
}
